<template>
  <div class="container">

    <breadcrumb-group :items="breadcrumbItems" v-if="!isAuWallet()"/>

    <heading-one class="-margin-md">au PAY 残高にチャージ（お借り入れ）</heading-one>

    <errors-alert :errors="errors"></errors-alert>

    <wizard-group class="-margin-md">
      <main-wizard :active-index="0" type="mb"></main-wizard>
    </wizard-group>

    <p class="_mb-0">au PAY 残高にチャージいたします。</p>
    <p>お客さまのau PAY 残高については<a href="https://wallet.auone.jp/index.html" class="btn-text textlink" target="_blank">au PAY サイト</a>にてご確認ください。</p>

    <p>＜ご注意＞</p>
    <p><router-link :to="{path: '#'}" v-scroll-to="{el: '#attention',  offset: -150}" class="textlink">以下に該当する場合</router-link>は、au PAY 残高にチャージができませんので、他のお借り入れ方法にてご利用ください。</p>
    <form @submit.prevent="submitValidateDepositIntoPrepaid" novalidate>
      <table-box class="_mb-md-30 _mb-sm-20 _mt-30">
        <table-body>
          <table-row>
            <table-header class="-requires">
              チャージ予定日
            </table-header>
            <table-data class="-pctextright">
              お手続き完了後、すぐにご利用いただけます。
            </table-data>
          </table-row>
          <table-row>
            <table-header class="-requires">
              ご利用可能額
            </table-header>
            <table-data class="-pctextright">
              {{depositIntoPrepaid.available_credit | numberToCurrency }}
            </table-data>
          </table-row>
        </table-body>
      </table-box>
      <amount-box class="_mb-md-60 _mb-sm-25" v-model="userData.amount" ></amount-box>

      <small>※以下の場合はご利用いただけませんので、他のお借り入れ方法にてご利用ください。</small>

      <list-group id="attention" class="-normal _mt-10">
        <list-item class="-normal">au PAY プリペイドカードをお持ちでないまたは、ご登録名義が異なる場合</list-item>
        <list-item class="-normal">au PAY 残高のチャージ上限額を超える場合</list-item>
        <list-item class="-normal">システムメンテナンス時間帯など</list-item>
      </list-group>

      <template v-if="!isAuWallet()">
        <heading-four class="_mt-20 _mb-10">その他のお借り入れ方法</heading-four>
        <btn-text routerName="mb011" class="-next -ib _mb-md-10 _mb-sm-15">ご登録口座へのお振込み</btn-text><br>
        <btn-text routerName="sv025" target="_blank" class="-next -ib">セブン銀行スマホＡＴＭ</btn-text>
      </template>

      <btngroup-double class="-margin-lg">
        <btn-main slot="main" class="-main" @click.prevent="submitValidateDepositIntoPrepaid">確認画面へ</btn-main>
        <btn-back slot="back" class="-back -sm" routerName="mb001" v-if="!isAuWallet()">戻る</btn-back>
      </btngroup-double>
    </form>
  </div><!-- container -->
</template>

<script>
import { initCredentials } from '../utils/Auth'
import { getUserDataForMemberLambdaInvoke, depositIntoPrepaidLambdaInvoke, validateDepositIntoPrepaidLambdaInvoke } from '../utils/LambdaHelper'
import { isAuWallet } from '../utils/UserAgent'
import HeadingOne from '../components/heading/HeadingOne'
import ErrorsAlert from '../components/alert/ErrorsAlert'
import WizardGroup from '../components/wizard/WizardGroup'
import MainWizard from '../components/wizard/MainWizard'
import TableBox from '../components/tables/TableBox'
import TableBody from '../components/tables/TableBody'
import TableRow from '../components/tables/TableRow'
import TableHeader from '../components/tables/TableHeader'
import TableData from '../components/tables/TableData'
import AmountBox from '../components/box/AmountBox'
import BtngroupDouble from '../components/button/BtngroupDouble'
import BtnMain from '../components/button/BtnMain'
import BtnBack from '../components/button/BtnBack'
import HeadingFour from '../components/heading/HeadingFour'
import BtnText from '../components/button/BtnText'
import ListGroup from '../components/list/ListGroup'
import ListItem from '../components/list/ListItem'

export default {
  name: 'Mb-012',
  metaInfo: {
    title: 'au PAY 残高にチャージ（お借り入れ）｜お借り入れ',
    meta: [
      {name: 'description', content: 'au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。'},
      {name: 'keywords', content: 'au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員,会員サイト'}
    ]
  },
  components: {
    ListItem,
    ListGroup,
    BtnText,
    HeadingFour,
    BtnBack,
    BtnMain,
    BtngroupDouble,
    AmountBox,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    MainWizard,
    WizardGroup,
    ErrorsAlert,
    HeadingOne
  },
  data () {
    return {
      breadcrumbItems: [{
        text: 'トップ',
        routerName: 'mb001'
      },
      {
        text: 'au PAY 残高にチャージ（お借り入れ）',
        active: true
      }
      ],
      errors: {},
      isDisabled: false,
      inputAmount: '',
      depositIntoPrepaid: {
        available_credit: ''
      },
      userData: {
        amount: ''
      }
    }
  },
  methods: {
    submitValidateDepositIntoPrepaid: function () {
      try {
        if (this.isDisabled) {
          return
        }
        this.isDisabled = true
        this.errors = {}
        initCredentials().then(res => {
          validateDepositIntoPrepaidLambdaInvoke(this.userData).then(res => {
            if (res.hasOwnProperty('body')) {
              let resBody = JSON.parse(res.body)
              this.errors = res.errors || {}
              if (resBody.event.inputs.prepaid_result === '5002' || resBody.event.inputs.prepaid_result === '5004') {
                this.errors = {'prepaid_result': ['glt_no_prepaid']}
                this.scrollTop()
                this.isDisabled = false
              } else if (Object.keys(this.errors).length > 0) {
                this.scrollTop()
                this.isDisabled = false
              } else if (resBody.event.inputs.prepaid_result !== '0000') {
                this.errors = {'prepaid_result': ['glt_invalid']}
                this.scrollTop()
                this.isDisabled = false
              } else {
                this.$router.push({name: 'mb014'})
              }
            } else {
              this.$router.push({name: 'SessionTimeOut'})
            }
          }).catch(error => {
            this.goToErrorPage(error)
          })
        }).catch(error => {
          this.goToErrorPage(error)
        })
      } catch (e) {
        this.goToErrorPage(e)
      }
    },
    isAuWallet: function () {
      return isAuWallet()
    }
  },
  mounted () {
    try {
      getUserDataForMemberLambdaInvoke().then(res => {
        for (let key in res) {
          if (this.userData.hasOwnProperty(key)) {
            this.userData[key] = res[key]
          }
        }
      }).catch(error => {
        this.goToErrorPage(error)
      })
      depositIntoPrepaidLambdaInvoke().then(res => {
        let resBody = JSON.parse(res.body)
        for (let key in resBody) {
          if (this.depositIntoPrepaid.hasOwnProperty(key)) {
            this.depositIntoPrepaid[key] = resBody[key]
          }
        }
      }).catch(error => {
        this.goToErrorPage(error)
      })
    } catch (e) {
      this.goToErrorPage(e)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/stylesheets/styles";
  .btn-text {
    &:hover {
      text-decoration: underline;
      color: $orange;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Mb012.vue